import Grid from "@material-ui/core/Grid";
import ArrivedIcon from "@material-ui/icons/LocalShipping";
import { CommodityInput } from "components/inputs/CommodityInput";
import { CoolerTypeSelect } from "components/inputs/CoolerTypeSelect";
import { CountryISOCodeInput } from "components/inputs/CountryISOCodeInput";
import { HiddenInput } from "components/inputs/HiddenInput";
// import { isExternalNotApproved } from 'utils/checker/entity';
import { OrderStatusEditField } from "components/inputs/OrderStatusEditField";
import { PlaceSelectInput } from "components/inputs/PlaceSelectInput";
import { SelectEnumInput } from "components/inputs/SelectEnumInput";
import { SelectUppercaseInput } from "components/inputs/SelectUppercaseInput";
import { useTerminalsContext } from "contexts/TerminalsProvider";
import { ExternalTerminalConnectionStatus } from "entities/ExternalTerminalConnectionStatus";
import React, { useMemo, useState } from "react";
import {
	NumberInput,
	ReferenceInput,
	SelectInput,
	TextInput,
	maxLength,
	translate,
	useDataProvider,
	usePermissions,
	useSaveModifiers,
	useTranslate,
} from "react-admin";
import { useForm, useFormState } from "react-final-form";
import { useSelector } from "react-redux";
import { isStorageModuleEnabled } from "utils/storageModule";

import { formatPhoneNumber } from "../../../components/fields/PhoneField";
import { FormGroupGrid, GridForm, GridInput } from "../../../components/GridForm";
// import { isExternalNotApproved } from 'utils/checker/entity';
import { NumberInputEx } from "../../../components/inputs";
import { CompanySelect, CompanyText, DateInput, TimeInput } from "../../../components/inputs";
import { PhoneInput } from "../../../components/inputs";
import { OrderReferenceInput } from "../../../components/inputs/OrderReferenceInput";
import { OSFCUserSelectInput } from "../../../components/inputs/OSFCUserSelect";
import { PortInput } from "../../../components/inputs/PortInput";
import { SelectTextInput } from "../../../components/inputs/SelectTextInput";
import TerminalDatesInput from "../../../components/inputs/TerminalDatesInput";
import { ReadOnlyInput } from "../../../components/inputs/TextReadonlyInput";
import { YesNoInput } from "../../../components/inputs/YesNoInput";
import {
	AllCustomerRoles,
	AppManagerRoles,
	OrderService,
	OrderStatus,
	OrderStatusEditOrderTerminal,
	UserRole,
	UserRoleByCompanyType,
	etdThirdAssigneeServices,
	perEligibleServices,
} from "../../../entities";
import HideableOrderField from "../../../entities/HideableOrderField";
import { LabelSource } from "../../../entities/LabelSource";
import { useTerminalFieldVisibility } from "../../../hooks/useTerminalFieldVisibility";
import { checkIsRankDisabled } from "../../../utils/checker/order";
import { isInArray } from "../../../utils/general";
import { rankChoicesGetter } from "../../../utils/getter";
import { validateArea, validateStoragePlace } from "../../../utils/validation/order";
import { validatePlaceLength, validateRankField } from "../../../utils/validation/order";
import { required } from "../../../utils/validation/required";
import { requiredIfNoFieldValue } from "../../../utils/validation/requiredIfNoFieldValue";
import { ColdStorageSection } from "./ColdStorageSection";
import { CustomFieldsBlock } from "./CustomFieldsBlock";
import { ExtraWorkSection } from "./ExtraWorkSection";
import { LoadingOrderInput } from "./inputs/LoadingOrderInput";
import { PrintedDocsInput } from "./inputs/PrintedDocsInput";
import { OrderManagerServiceInput, ServiceInput } from "./inputs/ServiceInput";
import { TransporterInput } from "./inputs/TransporterInput";
import { TripNumberInput } from "./inputs/TripNumberInput";
import { OrderProductArticlesBlock } from "./OrderProductArticlesBlock";
import {
	ArrivedPopup,
	DangerTextInputForInternalNotes,
	ETAETDFormGroup,
	ResponsiveIconButton,
	ViewDraftOrdersUtilComponent,
	etaEtdPorts,
	useEtaEtdSync,
	useXPartyChange,
} from "./shared";

const styleForButton = {
	marginTop: "7vh",
};

const rowGroupStyle = {
	borderBottom: "2px solid #bdbdbd",
	paddingBottom: 4,
	marginBottom: 4,
};

export const ETAETDBlock = ({
	isAddMode,
	prefix,
	permissions,
	isFieldHidden,
	isColdStorageService,
	handleAreaChange,
	handleLabelSourceChange,
	onIsDocForNfsaChange,
	...props
}) => {
	const form = useForm();
	const { values } = useFormState();
	const byTerminalFilter = { terminal_id: [values["terminal_id"]] };
	const { data: terminals } = useTerminalsContext();
	const currentTerminal = terminals[values["terminal_id"]];
	const usesStorageModule = isStorageModuleEnabled(currentTerminal);
	const order_storage_place_field = usesStorageModule ? "storage_place_id" : "area_id";
	const isOutgoingPlukk =
		usesStorageModule && values.service === OrderService.intoPlukkStorage && values.etd_date;
	const validateOrderStoragePlace = usesStorageModule ? validateStoragePlace : validateArea;
	const isTotalsLocked = isAddMode
		? isColdStorageService ||
		  (isOutgoingPlukk && !!currentTerminal?.should_create_pallets_from_packing_list_doc)
		: (isColdStorageService || isOutgoingPlukk) && !!values.has_pallets;

	const externalTerminalFilter = {
		status: ExternalTerminalConnectionStatus.connected,
	};
	const externalTerminalDisabled = prefix === "eta" || !currentTerminal;
	if (currentTerminal) {
		externalTerminalFilter["own_terminal_guid"] = [terminals[values["terminal_id"]].guid];
	}
	// const companyId = values.company_id || props.companyId;
	// const handleDriverChange = useDriverChange(prefix);
	const [
		handle3dPartyChangeOnTruck,
		handle3dPartyChangeOnTrailer,
		handleXPartyChangeOnDriver,
		handleXPartyChangeOn4pl,
	] = useXPartyChange(prefix);
	const handleEtaEtdSync = useEtaEtdSync(prefix);
	// const drivers = useSelector(driversSelector);

	const isAppManager = isInArray(AppManagerRoles, permissions.role);

	const isDisabledForEditing = isAppManager ? false : !!values[`${prefix}_3rd_party`];

	const isIntoPlukkStorage = values.service === OrderService.intoPlukkStorage;
	const isCrossDock = values.service === OrderService.crossDock;

	const dateRequiredValueKeyPrefix = prefix === "eta" ? "etd" : "eta";
	const portKey = etaEtdPorts[prefix];

	// const currentDriver = drivers[values[`${prefix}_driver_id`]];
	const filterCompanyId = isAppManager
		? values[`${prefix}_4th_party`] || values[`${prefix}_3rd_party`] || 0
		: 0;
	const currentTransportFilter = {
		no_range: true,
		is_deleted: false,
		company_id: filterCompanyId,
	};
	const currentTransportSort = { field: "name", order: "ASC" };

	// const currentTransporter = values[`${prefix}_3rd_party`];
	const currentDriverFilter = {
		no_range: true,
		is_blocked: false,
		is_deleted: false,
		company_id: filterCompanyId,
	};
	const currentDriverSort = { field: "first_name", order: "ASC" };

	const arrivedPopupAnchorEl = React.useRef(null);

	let arrivedPopupProps = null;
	if (!isAddMode) {
		arrivedPopupProps = {
			...props,
			disabled: props.disabled || (props.enabledFields && !props.enabledFields[props.source]),
			prefix,
			arrivedPopupAnchorEl,
			isArrived: `is_${prefix}_arrived`,
			timeKey: `${prefix}_time`,
			slotTimeKey: `${prefix}_slot_time`,
			portKey,
			byTerminalFilter: byTerminalFilter,
		};
		if (
			!arrivedPopupProps.disabled &&
			props.enabledFields &&
			(!props.enabledFields[arrivedPopupProps.timeKey] ||
				!props.enabledFields[arrivedPopupProps.slotTimeKey] ||
				!props.enabledFields[arrivedPopupProps.portKey])
		) {
			arrivedPopupProps.disabled = true;
		}
	}

	// const isNot3rdPartyRole = UserRoleByCompanyType.customer_and_transporter_roles.indexOf(props.permissions.role) === -1

	const placePrefix = prefix === "eta" ? "from" : "to";

	const handle3dPartyChange = (e) => {
		handle3dPartyChangeOnTruck(e);
		handle3dPartyChangeOnTrailer(e);
		handleXPartyChangeOnDriver(e);
		handleXPartyChangeOn4pl(e);
	};

	const handle4plChange = (e) => {
		handle3dPartyChangeOnTruck(e);
		handle3dPartyChangeOnTrailer(e);
		handleXPartyChangeOnDriver(e);
	};

	return (
		<ETAETDFormGroup {...props} prefix={prefix}>
			{/* Row 1: Date, Time, Arrived, Slot time, Port */}
			<FormGroupGrid style={rowGroupStyle}>
				<GridInput xs={6} sm={3}>
					<TerminalDatesInput
						component={DateInput}
						source={`${prefix}_date`}
						validate={[
							isIntoPlukkStorage
								? requiredIfNoFieldValue(`${dateRequiredValueKeyPrefix}_date`)
								: required(),
						]}
						onChange={handleEtaEtdSync}
					/>
				</GridInput>
				<GridInput xs={6} sm={3}>
					<TerminalDatesInput component={TimeInput} source={`${prefix}_time`} />
				</GridInput>
				{!isAddMode && (
					<Grid item xs={12} sm={1} ref={arrivedPopupAnchorEl}>
						<ArrivedPopup
							{...arrivedPopupProps}
							render={({ openPopup }) => (
								<ResponsiveIconButton
									onClick={openPopup}
									title={`${prefix.toUpperCase()} Arrived`}
									icon={<ArrivedIcon fontSize="small" />}
									disabled={arrivedPopupProps.disabled}
								/>
							)}
						/>
					</Grid>
				)}
				<GridInput xs={6} sm={3}>
					<TerminalDatesInput component={TimeInput} source={`${prefix}_slot_time`} />
				</GridInput>
				<GridInput
					xs={6}
					sm={2}
					component={PortInput}
					source={portKey}
					hidden={isAddMode}
					filter={byTerminalFilter}
				/>
			</FormGroupGrid>

			{/* Row 2: Transporters, Place, Seal, Trip number, Loading order, Show doc */}
			<FormGroupGrid style={rowGroupStyle}>
				<GridInput
					xs={6}
					sm={6}
					md={3}
					lg={3}
					component={TransporterInput}
					source={`${prefix}_3rd_party`}
					prefix={prefix}
					excludeIds={[values.company_id]}
					disabled={!values.company_id}
					onChange={handle3dPartyChange}
					hidden={isFieldHidden(`${prefix}_3rd_party`)}
				/>
				<GridInput
					xs={6}
					sm={6}
					md={3}
					lg={3}
					component={TransporterInput}
					source={`${prefix}_4th_party`}
					prefix={prefix}
					excludeIds={[values.company_id, values[`${prefix}_3rd_party`]]}
					disabled={!values.company_id || !values[`${prefix}_3rd_party`]}
					onChange={handle4plChange}
					hidden={isFieldHidden(`${prefix}_4th_party`)}
				/>
				<GridInput
					xs={6}
					sm={6}
					md={3}
					lg={3}
					isDefaultTextMode
					component={SelectTextInput}
					sourceText={`place_${placePrefix}`}
					sourceSelect={`${prefix}_external_terminal_id`}
					reference="external-terminal-links"
					optionText="external_name"
					filter={externalTerminalFilter}
					sort={{ field: "external_name", order: "ASC" }}
					validate={[validatePlaceLength]}
					disabledSelect={externalTerminalDisabled}
					allowEmpty
					hidden={isFieldHidden(`place_${placePrefix}`)}
				/>
				<GridInput
					xs={6}
					sm={6}
					md={3}
					lg={3}
					component={CountryISOCodeInput}
					source={`place_${placePrefix}_country_code`}
					hidden={isFieldHidden(`place_${placePrefix}_country_code`)}
				/>
				<GridInput
					xs={6}
					sm={6}
					md={3}
					lg={2}
					component={YesNoInput}
					source={prefix === "eta" ? "seal" : "plumb"}
					defaultValue={false}
					hidden={isFieldHidden(prefix === "eta" ? HideableOrderField.SEAL : HideableOrderField.PLUMB)}
				/>
				<GridInput
					xs={6}
					sm={6}
					md={3}
					lg={4}
					component={TextInput}
					source={prefix === "eta" ? "seal_number" : "plumb_number"}
					resettable
					hidden={isFieldHidden(prefix === "eta" ? HideableOrderField.SEAL_NUMBER : HideableOrderField.PLUMB_NUMBER)}
				/>
				<GridInput
					xs={6}
					sm={6}
					md={3}
					lg={3}
					component={TripNumberInput}
					source={prefix === "eta" ? "incoming_trip_number" : "outgoing_trip_number"}
					hidden={isFieldHidden(prefix === "eta" ? HideableOrderField.INCOMING_TRIP_NUMBER : HideableOrderField.OUTGOING_TRIP_NUMBER)}
				/>
				<GridInput
					xs={6}
					sm={6}
					md={3}
					lg={3}
					component={LoadingOrderInput}
					source={prefix === "eta" ? "unloading_sequence" : "loading_sequence"}
					hidden={isFieldHidden(prefix === "eta" ? HideableOrderField.UNLOADING_SEQUENCE : HideableOrderField.LOADING_SEQUENCE)}
				/>
			</FormGroupGrid>

			{/* Row 3: Truck, Trailer, Driver, Phone, Show doc, NFSA doc */}
			<FormGroupGrid style={rowGroupStyle}>
				<GridInput
					xs={12}
					sm={6}
					md={prefix === "eta" ? 6 : 4}
					lg={prefix === "eta" ? 3 : 2}
					component={SelectTextInput}
					label={"resources.orders.fields." + prefix + "_truck"}
					sourceText={`${prefix}_truck`}
					sourceSelect={`${prefix}_truck_id`}
					reference="trucks"
					source3rdParty={`${prefix}_3rd_party`}
					filter={currentTransportFilter}
					sort={currentTransportSort}
					disabled={isDisabledForEditing}
					validate={[maxLength(64)]}
					textProps={{ inputProps: { style: { textTransform: "uppercase" } } }}
					hidden={isFieldHidden(`${prefix}_truck`)}
				/>
				<GridInput
					xs={12}
					sm={6}
					md={prefix === "eta" ? 6 : 4}
					lg={prefix === "eta" ? 3 : 2}
					component={SelectTextInput}
					label={"resources.orders.fields." + prefix + "_trailer"}
					sourceText={`${prefix}_trailer`}
					sourceSelect={`${prefix}_trailer_id`}
					reference="trailers"
					source3rdParty={`${prefix}_3rd_party`}
					filter={currentTransportFilter}
					sort={currentTransportSort}
					disabled={isDisabledForEditing}
					validate={[maxLength(64)]}
					textProps={{ inputProps: { style: { textTransform: "uppercase" } } }}
					hidden={isFieldHidden(`${prefix}_trailer`)}
				/>
				<GridInput
					xs={12}
					sm={6}
					md={4}
					lg={2}
					component={SelectTextInput}
					sourceText={`${prefix}_driver`}
					sourceSelect={`${prefix}_driver_id`}
					reference="drivers"
					optionText={(record) =>
						`${record.first_name} ${record.last_name} | ${formatPhoneNumber(record.phone)}`
					}
					filter={currentDriverFilter}
					sort={currentDriverSort}
					disabled={isDisabledForEditing}
					hidden={isFieldHidden(`${prefix}_driver`)}
				/>
				<GridInput
					xs={12}
					sm={6}
					md={4}
					lg={2}
					component={PhoneInput}
					source={`${prefix}_driver_phone`}
					disabled={isDisabledForEditing}
					hidden={isFieldHidden(`${prefix}_driver_phone`)}
				/>
				{isFieldHidden(`${prefix}_show_doc_for_trans`) ? (
					<HiddenInput source={`${prefix}_show_doc_for_trans`} defaultValue={true} />
				) : (
					<GridInput
						xs={6}
						sm={6}
						md={4}
						lg={2}
						component={YesNoInput}
						source={`${prefix}_show_doc_for_trans`}
						label={"resources.orders.fields." + prefix + "_show_doc"}
						defaultValue={true}
						disabled={!isDisabledForEditing}
					/>
				)}
				{prefix === "etd" && (
					<GridInput
						xs={6}
						sm={6}
						md={4}
						lg={2}
						component={YesNoInput}
						source="is_doc_for_nfsa"
						defaultValue={false}
						onChange={onIsDocForNfsaChange}
						hidden={isFieldHidden(HideableOrderField.IS_DOC_FOR_NFSA)}
					/>
				)}
			</FormGroupGrid>

			{/* Row 4: Goods & Handling (ETA) or Storage allocation (ETD) + Assignee */}
			<FormGroupGrid>
				{prefix === "eta" ? (
					<>
						<GridInput
							xs={6}
							sm={4}
							md={3}
							lg={2}
							hidden={
								values.service === OrderService.reloadCarCar ||
								isFieldHidden(HideableOrderField.COOLER_TYPE_ID)
							}
						>
							<CoolerTypeSelect filter={{ order_service: values.service }} uppercase />
						</GridInput>
						<GridInput
							xs={4}
							sm={3}
							md={2}
							lg={2}
							component={NumberInputEx}
							source="pallets"
							min={0}
							max={100}
							step={10}
							disabled={isTotalsLocked}
							hidden={isFieldHidden(HideableOrderField.PALLETS)}
						/>
						<GridInput
							xs={4}
							sm={3}
							md={2}
							lg={2}
							component={NumberInputEx}
							source="boxes"
							disabled={isTotalsLocked}
							min={0}
							max={100}
							step={5}
							hidden={isFieldHidden(HideableOrderField.BOXES)}
						/>
						<GridInput
							xs={4}
							sm={3}
							md={2}
							lg={2}
							component={NumberInputEx}
							type="float"
							digitsCount={2}
							source="kilos"
							min={0}
							max={1000}
							step={100}
							disabled={isTotalsLocked}
							hidden={isFieldHidden(HideableOrderField.KILOS)}
						/>
						<GridInput
							xs={6}
							sm={4}
							md={3}
							lg={2}
							component={CommodityInput}
							source="commodity_id"
							hidden={isFieldHidden(HideableOrderField.COMMODITY_ID)}
						/>
						{!isColdStorageService && (
							<GridInput
								xs={6}
								sm={4}
								md={3}
								lg={2}
								component={OSFCUserSelectInput}
								source="assignee_1"
								hidden={isFieldHidden(HideableOrderField.ASSIGNEE_1)}
							/>
						)}
					</>
				) : (
					<>
						{(isIntoPlukkStorage || isCrossDock) && (
							<>
								<GridInput
									xs={6}
									sm={4}
									md={2}
									lg={2}
								>
									<PlaceSelectInput
										source={order_storage_place_field}
										label={`resources.orders.fields.${order_storage_place_field}`}
										terminalId={values["terminal_id"]}
										onChange={handleAreaChange}
										validate={validateOrderStoragePlace}
									/>
								</GridInput>
								{!usesStorageModule ? (
									<GridInput
										xs={4}
										sm={3}
										md={2}
										lg={2}
										component={YesNoInput}
										source="is_area_blocked"
										disabled={!values.area_id}
										hidden={isFieldHidden(HideableOrderField.IS_AREA_BLOCKED)}
									/>
								) : null}
							</>
						)}
						<GridInput
							xs={4}
							sm={3}
							md={2}
							lg={2}
							component={PrintedDocsInput}
							source="printed_doc"
							defaultValue={false}
							hidden={isFieldHidden(HideableOrderField.PRINTED_DOC)}
						/>
						{(isIntoPlukkStorage || isCrossDock) && (
							<>
								<GridInput
									xs={4}
									sm={3}
									md={2}
									lg={2}
									component={SelectEnumInput}
									onChange={handleLabelSourceChange}
									options={{ format: "" }}
									source="label_source"
									key={"label_source"}
									enumName="label_source"
									enumObj={LabelSource}
									hidden={isFieldHidden(HideableOrderField.LABEL_SOURCE)}
								/>
								<GridInput
									xs={4}
									sm={3}
									md={2}
									lg={2}
									component={NumberInputEx}
									options={{ format: "" }}
									source="label"
									disabled={!values["label_source"]}
									hidden={isFieldHidden(HideableOrderField.LABEL)}
								/>
							</>
						)}
						<GridInput
							xs={6}
							sm={4}
							md={2}
							lg={2}
							component={OSFCUserSelectInput}
							source="assignee_2"
							hidden={isFieldHidden(HideableOrderField.ASSIGNEE_2)}
						/>
						{etdThirdAssigneeServices.includes(values.service) && (
							<GridInput
								xs={6}
								sm={4}
								md={2}
								lg={2}
								component={OSFCUserSelectInput}
								source="assignee_3"
								hidden={isFieldHidden(HideableOrderField.ASSIGNEE_3)}
							/>
						)}
					</>
				)}
			</FormGroupGrid>

			{/* Row 5: All assignees for Cold Storage (ETA only) */}
			{isColdStorageService && prefix === "eta" && (
				<FormGroupGrid>
					<GridInput
						xs={6}
						sm={4}
						md={4}
						lg={4}
						component={OSFCUserSelectInput}
						source="assignee_1"
						hidden={isFieldHidden(HideableOrderField.ASSIGNEE_1)}
					/>
					<GridInput
						xs={6}
						sm={4}
						md={4}
						lg={4}
						component={OSFCUserSelectInput}
						source="assignee_2"
						hidden={isFieldHidden(HideableOrderField.ASSIGNEE_2)}
					/>
					<GridInput
						xs={6}
						sm={4}
						md={4}
						lg={4}
						component={OSFCUserSelectInput}
						source="assignee_3"
						hidden={isFieldHidden(HideableOrderField.ASSIGNEE_3)}
					/>
				</FormGroupGrid>
			)}
		</ETAETDFormGroup>
	);
};

export const FormManager = ({ isAddMode, ...props }) => {
	const form = useForm();
	const { permissions } = usePermissions();
	const { values, initialValues } = useFormState();
	const [customFields, setCustomFields] = useState([]);
	const dataProvider = useDataProvider();
	const translate = useTranslate();
	const [selectedCompany, setSelectedCompany] = useState(null);
	const isColdStorageService = values.service === OrderService.coldStorage;
	const { isFieldHidden } = useTerminalFieldVisibility(values?.terminal_id);
	const { data: terminals } = useTerminalsContext();
	const usesStorageModule = isStorageModuleEnabled(terminals[values["terminal_id"]]);

	const resetColdStorageFields = () => {
		form.change("is_reefer", null);
		form.change("is_photo_of_label", null);
		form.change("container_number", null);
		form.change("total_boxes", null);
	};

	const onCompanyChange = (val) => {
		if (val) {
			dataProvider.getOne("customer-companies", { id: val }).then((data) => {
				form.batch(() => {
					form.change("commodity_id", data.data.commodity_id);
					form.change("plumb", data.data.plumb);
					form.change("seal", data.data.seal);
					form.change("terminal_id", data.data.terminal_id);
					form.change("set_order_completed", data.data.set_order_completed);
					if (!data.data.terminal_id) {
						form.change("service", null);
					}
					onTerminalChange(data.data.terminal_id);
					if (values.service == OrderService.coldStorage) {
						form.change("container_number", null);
						form.change("total_boxes", null);
						form.change("is_reefer", data.data.cold_storage_is_reefer);
						form.change("cooler_type_id", data.data.cold_storage_temperature_type);
						form.change("is_photo_of_label", data.data.cold_storage_is_photo_of_label);
					}
				});
				setSelectedCompany(data.data);
			});
			setCustomFields([]);
			form.change("custom_fields", []);
			dataProvider
				.getList("custom-fields", {
					pagination: { page: 0, perPage: -1 },
					sort: { field: "id", order: "ASC" },
					filter: { company_id: val },
				})
				.then((data) => {
					if (data?.data) {
						const processedData = data.data.map((item) => {
							return {
								id: null,
								field_id: item.id,
								name: item.name,
								type: item.type,
								value: null,
								key: item.key,
							};
						});
						setCustomFields(processedData);
						form.change("custom_fields", processedData);
					}
				});
		} else {
			form.batch(() => {
				form.change("commodity_id", null);
				// form.change("area_id", null);
				form.change("plumb", false);
				form.change("seal", false);
				form.change("terminal_id", null);
				onTerminalChange(null);
				form.change("set_order_completed", false);
				form.change("is_copy_documents", false);
				setCustomFields([]);
				resetColdStorageFields();
			});
		}
	};

	const onTerminalChange = (val) => {
		form.change("port_in", null);
		form.change("port_out", null);
		form.change("storage_place_id", null);
		form.change("area_id", null);
		form.change("is_area_blocked", false);
		form.change("is_per", false);
	};

	React.useEffect(() => {
		if (isAddMode && props.record && props.record.company_id) {
			dataProvider.getOne("customer-companies", { id: props.record.company_id }).then((data) => {
				form.change("is_copy_documents", data.data.copy_docs_on_clone);
			});
		} else {
			setCustomFields(props.record.custom_fields);
		}
	}, [isAddMode, props.record]);

	const rankChoices = useMemo(() => rankChoicesGetter(props.record), [props.record]);

	const onIsDocForNfsaChange = React.useCallback(
		(item) => {
			const englishText = "\nDocuments MUST be obtained from the Norwegian Food Safety Authority";
			const norwegianText = "\nDokumenter MÅ hentes på Mattilsynet";
			const old_internal_notes_text = values.internal_notes ? values.internal_notes : "";
			const newValueInternalNotes = item.target.value
				? old_internal_notes_text + englishText + norwegianText
				: old_internal_notes_text.replace(englishText + norwegianText, "");
			form.change("internal_notes", newValueInternalNotes);
		},
		[values.internal_notes, form]
	);

	if (!permissions) return null;

	const canChangeCustomerAndReference =
		isAddMode ||
		initialValues.status === OrderStatus.LOAD_IN_TERMINAL_STORAGE ||
		initialValues.status === OrderStatus.BOOKED ||
		initialValues.status === OrderStatus.DRAFT;

	// let statusDisabled = false;
	let enabledFields;

	if (props.record.deleted_at) {
		enabledFields = {};
	} else if (props.record.status === OrderStatus.ORDER_COMPLETED) {
		if (permissions.role === UserRole.admin || permissions.can_edit_completed_order)
			enabledFields = { status: true };
		else enabledFields = {};
	}
	// if (isExternalNotApproved(props.record.state)) {
	// 	enabledFields = {};
	// }

	const isTerminalDisabled = values["status"]
		? !OrderStatusEditOrderTerminal.includes(values["status"])
		: false;
	const isRankDisabled = checkIsRankDisabled(values);

	const handleLabelSourceChange = (event) => {
		const val = event.target.value;
		if (!val) {
			form.change("label", null);
		} else if (val === LabelSource.pallets) {
			form.change("label", values.pallets);
		} else if (val === LabelSource.boxes) {
			form.change("label", values.boxes);
		}
	};

	// const statusDisabled = (permissions.role !== UserRole.osfc_manager) && (
	// 	(props.record.status === OrderStatus.ORDER_COMPLETED)
	// );
	// const enabledFields = initialValues.status === OrderStatus.ORDER_COMPLETED ? {status: true} : undefined

	const handleAreaChange = (event) => {
		if (usesStorageModule) return;
		if (event.target.value) {
			if (values["service"] === OrderService.intoPlukkStorage && values["etd_date"]) {
				form.change("is_area_blocked", true);
			}
		} else {
			form.change("is_area_blocked", false);
		}
	};

	// const choices = props.record.rank ?  [{id: false, name: "NO (" +  props.record.rank + ")"}, {id: true, name: "YES (M)"}] :
	// 									 [{id: false, name: "NO ()"}, {id: true, name: "YES (M)"}];

	const isStatusDraft = values.status === OrderStatus.DRAFT;
	const isOrderDraft = props?.record ? props.record.status === OrderStatus.DRAFT : isStatusDraft;
	const isOrderProductArticleVisible = isColdStorageService && !isStatusDraft && !isAddMode;

	return (
		<React.Fragment>
			<ViewDraftOrdersUtilComponent {...props} />
			<GridForm {...props} enabledFields={enabledFields}>
				<HiddenInput source="isUpdatePartial" defaultValue={1} />
				<FormGroupGrid>
					{canChangeCustomerAndReference ? (
						<GridInput
							source="company_id"
							sm={2}
							component={CompanySelect}
							filter={{ no_transporters: true }}
							validate={!isStatusDraft ? [required()] : undefined}
							onChange={onCompanyChange}
							allowEmpty={isStatusDraft}
						/>
					) : (
						<GridInput source="company_id" sm={2} component={CompanyText} disabled={true} />
					)}
					<GridInput
						source="reference"
						sm={2}
						component={canChangeCustomerAndReference ? OrderReferenceInput : ReadOnlyInput}
						disabled={!canChangeCustomerAndReference}
						validate={!isStatusDraft ? [required()] : undefined}
					/>
					<GridInput sm={1}>
						<ReferenceInput
							source="terminal_id"
							reference="terminal"
							disabled={isTerminalDisabled}
							validate={[required()]}
							onChange={onTerminalChange}
						>
							<SelectInput optionText="name" />
						</ReferenceInput>
					</GridInput>
					<GridInput
						source="service"
						sm={1}
						component={OrderManagerServiceInput}
						company={selectedCompany}
						disabled={!isAddMode && isColdStorageService}
						validate={!isStatusDraft ? [required()] : undefined}
						defaultValue={!isStatusDraft ? OrderService.reloadCarCar : undefined}
						allowEmpty={isStatusDraft}
						isCouldStorageVisible={isAddMode || isColdStorageService}
					/>
					<GridInput
						sm={1}
						component={YesNoInput}
						source="is_per"
						defaultValue={false}
						hidden={
							isFieldHidden(HideableOrderField.IS_PER) ||
							!perEligibleServices.includes(values.service)
						}
					/>
					<GridInput sm={2} hidden={isAddMode} source="status" reference="order-statuses">
						<ReferenceInput>
							<OrderStatusEditField data={values} permissions={permissions} />
						</ReferenceInput>
					</GridInput>
					<GridInput sm={1} component={YesNoInput} source="priority" defaultValue={false} />
					{/* <GridInput sm={1} hidden={isAddMode} component={YesNoInput} label={translate("resources.orders.fields.rank_edit_label")}
						   source="rank" disabled={isRankDisabled}
						//    validate={validateRankField}
						   format={val => val === 'M' ? true : val===null || val===undefined ? false : typeof val === 'string' ? false : true }
				 		   parse={val => val === true ? 0 : null}
						   choices={choices}/> */}
					<GridInput
						sm={1}
						hidden={isAddMode}
						component={YesNoInput}
						source="rank"
						disabled={isRankDisabled}
						choices={rankChoices}
					/>

					<GridInput
						sm={1}
						component={YesNoInput}
						source="set_order_completed"
						defaultValue={false}
					/>
					{/* <GridInput sm={2} component={LoadNoInput} source="load_no" /> */}
				</FormGroupGrid>

				{/* <Grid item sm={12} md={12} lg={6}> */}
				<ETAETDBlock
					sm={12}
					md={12}
					lg={6}
					isAddMode={isAddMode}
					prefix="eta"
					permissions={permissions}
					{...props}
					enabledFields={enabledFields}
					isFieldHidden={isFieldHidden}
					isColdStorageService={isColdStorageService}
					handleAreaChange={handleAreaChange}
					handleLabelSourceChange={handleLabelSourceChange}
				/>
				{/* </Grid> */}
				{/* <Grid item sm={12} md={12} lg={6}> */}
				{!isColdStorageService ? (
					<ETAETDBlock
						sm={12}
						md={12}
						lg={6}
						isAddMode={isAddMode}
						prefix="etd"
						permissions={permissions}
						{...props}
						enabledFields={enabledFields}
						isFieldHidden={isFieldHidden}
						isColdStorageService={isColdStorageService}
						handleAreaChange={handleAreaChange}
						handleLabelSourceChange={handleLabelSourceChange}
						onIsDocForNfsaChange={onIsDocForNfsaChange}
					/>
				) : (
					<ColdStorageSection sm={12} md={12} lg={6} isAddMode={isAddMode} {...props} />
				)}
				{/* </Grid> */}

				{/* <Grid item xs={12} md={6} lg={3}> */}
				{!isColdStorageService && (
					<>
						<FormGroupGrid
							xs={12}
							md={6}
							lg={3}
							title={translate("resources.orders.block-label.split-loads")}
							hidden={isFieldHidden(HideableOrderField.SPLIT_LOAD)}
						>
							<GridInput
								xs={4}
								component={YesNoInput}
								source="split_load"
								defaultValue={false}
								hidden={isFieldHidden(HideableOrderField.SPLIT_LOAD)}
							/>
						</FormGroupGrid>
						<ExtraWorkSection
							isFieldHidden={isFieldHidden}
							disabled={isInArray(AllCustomerRoles, permissions.role)}
						/>
						{/* </Grid> */}
					</>
				)}
				{isOrderProductArticleVisible && !isOrderDraft && (
					<OrderProductArticlesBlock
						orderId={props.record.id}
						pallets={props.record.pallets}
						companyId={props.record.company_id}
						status={props.record.status}
						totalBoxes={props.record.total_boxes}
					/>
				)}
				{/* <DimensionsBlock {...props} /> */}

				<FormGroupGrid>
					<GridInput
						sm={12}
						md={6}
						component={TextInput}
						source="notes"
						multiline
						rows={6}
						validate={[maxLength(1024)]}
					/>
					<GridInput
						sm={12}
						md={6}
						className="red-border"
						component={DangerTextInputForInternalNotes}
						source="internal_notes"
						multiline
						rows={6}
						validate={[maxLength(1000)]}
					/>
				</FormGroupGrid>
				<CustomFieldsBlock customFields={customFields} enabledFields={enabledFields} />
			</GridForm>
		</React.Fragment>
	);
};
